import { connect } from 'react-redux';

import { toastr } from 'react-redux-toastr';
import ProductShow from '../../components/pages/show-product';
import Actions from '../../actions';
import ProductsAPI from '../../apis/products';
import BaseProductList from '../base/base-product-list';

import { addProductToCartNextActionEP, addProductToCartNotifyEP } from '../../errors/processors/add-product-to-cart';
import refreshOrderProcess from '../../services/refresh-order-process';
import translations from '../../../translations/app-translations.json';

const mapStateToProps = (state, ownProps) => ({
    lineItems: state.order.line_items,
    products: state.productList.products,
    order: state.order,
    currentZone: state.zones.currentZone,
    access_token: state.auth.access_token,
});

const mapDispatchToProps = (dispatch) => ({
    fetchProductFromAPI: (productId, locale, zoneId, callback) => {
        dispatch(Actions.displayLoader());

        ProductsAPI.getItem(productId, locale, zoneId).then((response) => {
            dispatch(Actions.addProduct(response.body));
            dispatch(Actions.hideLoader());

            callback(response.body);
        });
    },

    addProductToCart: (variantId, quantity = 1, zoneId, locale, order, userToken, extraData = null) => {
        dispatch(Actions.addingProductToCart());
        dispatch(Actions.addProductToCart(variantId, quantity, zoneId, locale, userToken, extraData))
            .then(() => {
                refreshOrderProcess(dispatch, locale, toastr, {
                    addingProductToCartAction: true,
                    successNotify: `${translations[locale]['item-added']}. ${translations[locale]['proceed-to-checkout']}.`,
                });
            })
            .catch((error) => {
                addProductToCartNotifyEP(locale, error, toastr);
                addProductToCartNextActionEP(dispatch, order, locale);
            });
    },
    emptyCart: (order, locale) => dispatch(Actions.emptyCart(order, locale)),
});

const ProductShowConnector = connect(mapStateToProps, mapDispatchToProps)(ProductShow);

export default BaseProductList(ProductShowConnector);



/** WEBPACK FOOTER **
 ** ./src/containers/product/product-show-connector.js
 **/